import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-563bd2a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bar" }
const _hoisted_2 = ["data-tooltip"]
const _hoisted_3 = ["data-tooltip"]
const _hoisted_4 = ["data-tooltip"]

import { computed, ref, watch } from 'vue'
import NP from 'number-precision'


export default /*#__PURE__*/_defineComponent({
  __name: 'Slider',
  props: {
    value: {},
    disabled: { type: Boolean, default: false },
    min: { default: 0 },
    max: { default: 100 },
    step: { default: 1 },
    range: { type: Boolean, default: false }
  },
  emits: ["update:value"],
  setup(__props: any, { emit: __emit }) {

const getBoundingClientRectViewLeft = (element: HTMLElement) => {
  return element.getBoundingClientRect().left
}

const props = __props

const emit = __emit

const sliderRef = ref<HTMLElement>()
const percentage = ref(0)
const start = ref(0)
const end = ref(0)
const handler = ref<'start' | 'end'>('end')

const getNewValue = (percentage: number) => {
  let diff = percentage / 100 * (props.max - props.min)
  if (props.step >= 1) diff = Math.fround(diff)
  else {
    const str = props.step.toString()
    const match = str.match(/^[0.]*([1-9])/)

    if (match) {
      const targetNumber = match[1]
      const position = str.indexOf(targetNumber) - 1
      if (position > 0) {
        const accuracy = Math.pow(10, position)
        diff = Math.fround(diff * accuracy) / accuracy
      }
    }
  }
  return NP.plus(diff, props.min)
}

const tooltipValue = computed(() => {
  return getNewValue(percentage.value)
})
const tooltipRangeStartValue = computed(() => {
  return getNewValue(start.value)
})
const tooltipRangeEndValue = computed(() => {
  return getNewValue(end.value)
})

watch(() => props.value, () => {
  if (props.max === props.min) return
  if (typeof props.value === 'number') {
    percentage.value = (props.value - props.min) / (props.max - props.min) * 100
  }
  else {
    start.value = (props.value[0] - props.min) / (props.max - props.min) * 100
    end.value = (props.value[1] - props.min) / (props.max - props.min) * 100
  }
}, {
  immediate: true,
})

const getPercentage = (e: MouseEvent | TouchEvent) => {
  if (!sliderRef.value) return 0
  const clientX = 'clientX' in e ? e.clientX : e.changedTouches[0].clientX
  let progress = (clientX - getBoundingClientRectViewLeft(sliderRef.value)) / sliderRef.value.clientWidth
  progress = Math.max(progress, 0)
  progress = Math.min(progress, 1)

  let _percentage = progress * 100
  const step = props.step / (props.max - props.min) * 100
  const remainder = _percentage % step

  if (remainder > 0) {
    if (remainder <= step / 2) _percentage = _percentage - remainder
    else _percentage = _percentage - remainder + step
  }
  return _percentage
}

// 双滑块（范围）模式
const updateRange = (e: MouseEvent | TouchEvent) => {
  const value = getPercentage(e)

  if (handler.value === 'start') start.value = value
  else end.value = value
}

const updateRangeEnd = (e: MouseEvent | TouchEvent) => {
  updatePercentage(e)
  const newValue = getNewValue(percentage.value)
  const oldValueArr = props.value as [number, number]
  const newValueArr: [number, number] = handler.value === 'start' ? [newValue, oldValueArr[1]] : [oldValueArr[0], newValue]
  if (newValueArr[0] > newValueArr[1]) {
    [newValueArr[0], newValueArr[1]] = [newValueArr[1], newValueArr[0]]
  }

  emit('update:value', newValueArr)

  document.removeEventListener('mousemove', updateRange)
  document.removeEventListener('touchmove', updateRange)
  document.removeEventListener('mouseup', updateRangeEnd)
  document.removeEventListener('touchend', updateRangeEnd)
}

// 单滑块模式
const updatePercentage = (e: MouseEvent | TouchEvent) => {
  percentage.value = getPercentage(e)
}

const updatePercentageEnd = (e: MouseEvent | TouchEvent) => {
  updatePercentage(e)
  const newValue = getNewValue(percentage.value)

  emit('update:value', newValue)

  document.removeEventListener('mousemove', updatePercentage)
  document.removeEventListener('touchmove', updatePercentage)
  document.removeEventListener('mouseup', updatePercentageEnd)
  document.removeEventListener('touchend', updatePercentageEnd)
}

const handleMousedown = (e: MouseEvent | TouchEvent) => {
  if (props.disabled) return

  if (props.range) {
    const _percentage = getPercentage(e)
    
    if (Math.abs(_percentage - start.value) < Math.abs(_percentage - end.value)) {
      handler.value = 'start'
    }
    else handler.value = 'end'

    document.addEventListener('mousemove', updateRange)
    document.addEventListener('touchmove', updateRange)
    document.addEventListener('mouseup', updateRangeEnd)
    document.addEventListener('touchend', updateRangeEnd)
  }
  else {
    document.addEventListener('mousemove', updatePercentage)
    document.addEventListener('touchmove', updatePercentage)
    document.addEventListener('mouseup', updatePercentageEnd)
    document.addEventListener('touchend', updatePercentageEnd)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["slider", { 'disabled': _ctx.disabled }]),
    ref_key: "sliderRef",
    ref: sliderRef,
    onMousedown: _cache[0] || (_cache[0] = $event => handleMousedown($event))
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.range)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", {
              class: "track",
              style: _normalizeStyle({ width: `${percentage.value}%` })
            }, null, 4),
            _createElementVNode("div", {
              class: "thumb",
              style: _normalizeStyle({ left: `${percentage.value}%` }),
              "data-tooltip": tooltipValue.value
            }, null, 12, _hoisted_2)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", {
              class: "track",
              style: _normalizeStyle({ width: `${end.value - start.value}%`, left: `${start.value}%` })
            }, null, 4),
            _createElementVNode("div", {
              class: "thumb",
              style: _normalizeStyle({ left: `${start.value}%` }),
              "data-tooltip": tooltipRangeStartValue.value
            }, null, 12, _hoisted_3),
            _createElementVNode("div", {
              class: "thumb",
              style: _normalizeStyle({ left: `${end.value}%` }),
              "data-tooltip": tooltipRangeEndValue.value
            }, null, 12, _hoisted_4)
          ], 64))
    ])
  ], 34))
}
}

})